import { prefetchTranslations } from '../services';
import {
  wixPatternsEnvironment,
  WixPatternsEssentials,
  WixPatternsEssentialsOverrides,
} from '../model';
import { loadStart } from '@wix/bex-utils/@wix/bi-logger-os-data/v2';
import { fixDomainForBI, parseFqdn } from '../util';

export interface WarmUpPickerParams {
  queryName: string;
  overrides?: Partial<WixPatternsEssentialsOverrides>;
}

export function warmUpPickerStandalone(
  wixPatternsEssentials: WixPatternsEssentials,
  params: WarmUpPickerParams,
) {
  const { errorMonitor, createEssentials } = wixPatternsEssentials;
  const environment = wixPatternsEnvironment(wixPatternsEssentials.environment);
  prefetchTranslations({ errorMonitor })(environment.language);

  const { queryName } = params;

  const fqdn = parseFqdn(queryName);

  const { biLoggerFactory } = createEssentials({});

  if (biLoggerFactory) {
    const bi = biLoggerFactory()
      .updateDefaults({
        artifactId: environment.artifactId,
        componentName: environment.componentName,
        cairoVersion: environment.uiLibVersion,
        ...fqdn,
        type: 'standalone',
        componentType: 'Picker Standalone',
      })
      .logger();

    bi?.report(
      loadStart({
        ...({ maxItems: 1 } as {}),
        url: fixDomainForBI(window.location.href),
        featuresAvailability: JSON.stringify({}),
        ...(environment.providerType === 'bm' && {
          _hostingPlatform: 'business-manager',
        }),
      }),
    );
  }
}
